export default __webpack_public_path__ + "static/media/learn-more-mobile.acc83f1a.png";